import React from "react";
import { Checkbox } from "semantic-ui-react";

class CustomCheckbox extends React.Component {
  state = {
    checked: this.props.checked
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ checked: nextProps.checked });
  }

  onChange = (e, { checked }) => {
    this.setState({ checked }, () => this.props.onChange(checked));
  };

  render = () => (
    <Checkbox
      onClick={this.onChange}
      checked={this.state.checked}
      label={this.props.label}
    />
  );
}

export default CustomCheckbox;



// WEBPACK FOOTER //
// ./src/pages/shared/CustomCheckbox.jsx